/**
 * Mean daily volume over a window (ADR-0034). Null volumes are skipped, not
 * treated as 0 — a halted session is a real 0 and stays in the mean (R2b).
 */
function usableVolume(volume: number | null): volume is number {
  return volume !== null && Number.isFinite(volume) && volume >= 0;
}

export function averageVolume(volumes: readonly (number | null)[]): number | null {
  const usable = volumes.filter(usableVolume);
  if (usable.length === 0) return null;
  const mean = usable.reduce((sum, volume) => sum + volume, 0) / usable.length;
  return Number.isFinite(mean) ? mean : null;
}
